import React from 'react'
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useCitaPendiente } from './hooks/useCitaPendiente';

import { Error, Forbidden, Loader } from '../../components';
import { CitaCreate } from './components/CitaCreate';

import styles from './CitaPendiente.module.css';

export const CitaPendiente = () => {

    let { cita: citaId } = useParams();

    const { permisos } = useSelector(state => state.auth);

    const { citaPendienteQuery: { isLoading, isError, data: cita } } = useCitaPendiente(citaId);

    return (permisos.citaCreate) ? (
        <div className='row'>
            <div className="col">
                <div className={styles.panel + " " + styles.panelNoHeader}>
                    <div className={styles.header}>Crear cita</div>
                    <div className="row">
                        <div className="col">
                        {(isLoading)
                            ? <Loader />
                            : <>
                                {(isError)
                                    ? <Error />
                                    : <>
                                        <CitaCreate cita={cita} />
                                    </>
                                }
                            </>
                        }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : <Forbidden />
}
